import React, { useState, useEffect, useCallback } from "react";
import { Avatar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlineWarningAmber, MdBlock } from "react-icons/md";
import { MdKeyboardArrowDown } from "react-icons/md";
import IconButton from "@material-ui/core/IconButton";
import { Button } from "primereact/button";
import { Menu, MenuItem } from "@szhsin/react-menu";
import * as moderatorActions from "src/store/actions/Moderator/moderatoractions";
import ConfirmDialogDemo from "../ReusableModeratorComponents/Blockmembersmodal";
import crownImage from "src/Assets/images/crown.png";
import style from "src/Assets/css/Moderator/Managemembes.module.css";
import API from "../../../network";
import CircularProgress from "@material-ui/core/CircularProgress";
import WarningModal from "../ReusableModeratorComponents/WarnModal/WarningModal";
import { PiDotsThreeBold } from "react-icons/pi";
import AvatarBadge from "src/Components/AvatarBadge";
import alreadyImpactfulMemberImg from "src/Assets/images/already_impactful_img.png";
import feedstyles from "src/Assets/css/home/feedpost.module.css";

const isPrimaryModerator = (user, tenantId, userDetails, moderatingCommunitysData) => {
  if (!user) return false;

  const directIsPM =
    user.isPM == 1 ||
    user.isPM === "1" ||
    user.isPM === "Y" ||
    user.ispm == 1 ||
    user.ispm === "1" ||
    user.ispm === "Y" ||
    user.is_primary_moderator == 1 ||
    user.is_primary_moderator === "1" ||
    user.isCurrentCommunityPm == 1 ||
    user.isCurrentCommunityPm === "1" ||
    user.mainuserdata?.isPM == 1 ||
    user.mainuserdata?.isPM === "1" ||
    user.mainuserdata?.isPM === "Y" ||
    user.mainuserdata?.ispm == 1 ||
    user.mainuserdata?.ispm === "1" ||
    user.mainuserdata?.ispm === "Y" ||
    user.mainuserdata?.is_primary_moderator == 1 ||
    user.mainuserdata?.is_primary_moderator === "1" ||
    user.mainuserdata?.isCurrentCommunityPm == 1 ||
    user.mainuserdata?.isCurrentCommunityPm === "1";

  if (directIsPM) return true;

  const currentRestriction = moderatingCommunitysData?.restrictions?.find(
    (r) => String(r.tenantId) === String(tenantId)
  );
  const isCurrentCommunityPm =
    currentRestriction?.isPm === "1" ||
    currentRestriction?.isPm === 1 ||
    (String(userDetails?.userData?.tenantId) === String(tenantId) &&
      (userDetails?.userData?.isCurrentCommunityPm === "1" ||
        userDetails?.userData?.isCurrentCommunityPm == 1));

  if (isCurrentCommunityPm) {
    const loggedInId =
      userDetails?.userData?.User_ID ||
      userDetails?.userData?.userId ||
      userDetails?.userData?.id;
    const userId = user.id || user.userId || user.User_ID || user.userid;
    if (loggedInId && userId && String(loggedInId) === String(userId)) {
      return true;
    }
    if (
      userDetails?.userData?.displayName &&
      user.displayName &&
      userDetails.userData.displayName.trim().toLowerCase() ===
        user.displayName.trim().toLowerCase()
    ) {
      return true;
    }
  }

  return false;
};

const isModeratorUser = (user, tenantId, userDetails, moderatingCommunitysData) => {
  if (!user) return false;
  const isMod =
    user.isModerator == 1 ||
    user.isModerator == 2 ||
    user.isModerator === "1" ||
    user.isModerator === "2" ||
    user.mainuserdata?.isModerator == 1 ||
    user.mainuserdata?.isModerator == 2 ||
    user.mainuserdata?.isModerator === "1" ||
    user.mainuserdata?.isModerator === "2";

  return (
    isMod &&
    !isPrimaryModerator(user, tenantId, userDetails, moderatingCommunitysData)
  );
};

const Members = (props) => {
  const { tenantId, tenantName } = props;
  const data = useSelector(
    (state) => state.ManagemembersReducer.ManagemebersData,
  );
  const userDetails = useSelector(
    (state) => state.SignInReducer?.userDetails || {},
  );
  const moderatingCommunitysData = useSelector(
    (state) => state.ModeratorReducer?.moderatingCommunitysData || {},
  );

  const isLoading = useSelector(
    (state) => state.ManagemembersReducer.isLoading,
  );

  const [membersData, setMembersData] = useState([]);
  const [isWarningModalOpen, setWarningModalOpen] = useState(false);
  const [isBlockConfirmationModalOpen, setIsBlockConfirmationModalOpen] =
    useState(false);
  const [warnOrBlockUserId, setWarnOrBlockUserId] = useState(null);
  const [warnOrBlockUserName, setWarnOrBlockUserName] = useState(null);
  const [modalType, setModalType] = useState("");

  const getMembersData = useCallback(async () => {
    try {
      const formData = new FormData();
      formData.append("tenantId", tenantId);

      const res = await API.getBlockedUsers(formData);
      const userList = res?.data?.userList || [];
      const nonPmMembers = userList.filter(
        (user) =>
          !isPrimaryModerator(
            user,
            tenantId,
            userDetails,
            moderatingCommunitysData,
          ),
      );
      setMembersData(nonPmMembers);
    } catch (error) {
      console.error("Failed to fetch blocked users:", error);
      setMembersData([]);
    }
  }, [tenantId, userDetails, moderatingCommunitysData]);

  useEffect(() => {
    if (tenantId) {
      getMembersData();
    }
  }, [tenantId, getMembersData]);

  // const blockedUsersData = useSelector(
  //   (state) => state.ModeratorReducer.Blockedusersdata
  // );
  // const tenantValue = props.tenantId;

  const dispatch = useDispatch();
  // let serverImageURL = process.env.REACT_APP_SKOPIC_IMAGE;

  // const onBlockMemberSelect = (i) => {
  //   let id = i;
  //   if (userDetails && Object.keys(userDetails).length !== 0) {
  //     // // console.log(userDetails.userData.tenantId)
  //     // setTenantID([userDetails.userData.tenantId])
  //     // dispatch(moderatorActions.fetchBlockMembersData(`?tenantId=${userDetails.userData.tenantId}&selectedIds=${id}`))
  //   }
  //   // document.getElementById(id)
  // };

  // Manage members community Invite as Moderator in submenu of ManageMembers actions

  const OnInviteAsModerator = (userID) => {
    if (tenantId) {
      let formData = new FormData();
      formData.append("tenantId", tenantId);
      formData.append("selectedIds", userID);

      dispatch(moderatorActions.fetchInviteAsModerator(formData));
      alert("Invitation has been sent successfully");
    }
  };

  // Manage members community Remove as Moderator in submenu of ManageMembers actions

  const onRemoveAsModerator = (userID) => {
    if (tenantId) {
      let formData = new FormData();
      formData.append("tenantId", tenantId);
      formData.append("rejectedIds", userID);

      // dispatch(moderatorActions.fetchRemoveAsModerator(formData));
      API.inviteAsModerator(formData)
        .then((response) => {
          const updatedData = membersData.filter((each) => each.id !== userID);
          setMembersData(updatedData);
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
      alert("removed as moderator ");
    }
    // console.log(userID);
  };
  const handleRemoveImpactFullMember = async (
    nominatedId,
    userId,
    selectedTId,
  ) => {
    try {
      const formData = new FormData();

      formData.append("nominatedId", nominatedId);
      formData.append("nominatedstatus", "remove");
      formData.append("selectedTId", selectedTId);
      formData.append("userId", userId);

      const response = await API.nominateOrRemoveImpactFullMembers(formData);

      if (response?.status === 200 && response?.data?.status === "success") {
        setMembersData((prev) =>
          prev.map((member) =>
            member.id === userId
              ? {
                  ...member,
                  isImpactableMember: "No",
                  nominatedId: null,
                }
              : member,
          ),
        );
        alert("Removed from Impactful Member successfully");
      }
    } catch (error) {
      console.error("Failed to remove impactful member:", error);
    }
  };

  const onWarnUser = (id, userName) => {
    setWarningModalOpen(true);
    setWarnOrBlockUserId(id);
    setWarnOrBlockUserName(userName);
    setModalType("warn");
  };
  const onWarnModalClose = () => {
    setWarningModalOpen(false);
    setWarnOrBlockUserId(null);
    setWarnOrBlockUserName(null);
    setModalType("");
  };

  const onBlockUser = (id, userName) => {
    setWarningModalOpen(true);
    setWarnOrBlockUserId(id);
    setWarnOrBlockUserName(userName);
    setModalType("block");
  };
  const onUnblockUser = (id) => {
    setIsBlockConfirmationModalOpen(true);
    setWarnOrBlockUserId(id);
  };
  const onCloseUnBlockConfirmationModal = () => {
    setIsBlockConfirmationModalOpen(false);
    setWarnOrBlockUserId(null);
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          flex: 1,
          justifyContent: "center",
          marginTop: "100px",
        }}
      >
        <CircularProgress size={30} />
      </div>
    );
  }

  if (!membersData?.length) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "100px",
        }}
      >
        <p>No members found !</p>
      </div>
    );
  }

  return (
    <div className={style.container}>
      {membersData
        .filter(
          (result) =>
            !isPrimaryModerator(
              result,
              tenantId,
              userDetails,
              moderatingCommunitysData,
            ),
        )
        .map((result, i) => (
          <div key={`key-${result?.id}`} className={style.communityUsers}>
            <div className={style.childimage}>
              <AvatarBadge
                className={style.Linkedinimage}
                src={result.uimage}
                alt="image"
                isPrimaryModerator={isPrimaryModerator(
                  result,
                  tenantId,
                  userDetails,
                  moderatingCommunitysData,
                )}
                isModerator={isModeratorUser(
                  result,
                  tenantId,
                  userDetails,
                  moderatingCommunitysData,
                )}
              />
            <div>
              <span className={feedstyles.profilename}>
                {result?.displayName}
                {result?.isImpactableMember === "yes" && (
                  <img
                    src={alreadyImpactfulMemberImg}
                    alt="Impactful Member"
                    title="Impactful Member"
                    style={{
                      width: "18px",
                      height: "18px",
                      objectFit: "contain",
                      flexShrink: 0,
                      marginLeft: "5px",
                    }}
                  />
                )}
              </span>
              {result.isModerator === "1" || result.isModerator === "2" ? (
                <p style={{ margin: 0, fontSize: "14px", color: "gray" }}>
                  Moderator
                </p>
              ) : null}
            </div>
          </div>
          <div className={style.dropdown}>
            <Menu
              menuButton={
                <IconButton
                  style={{
                    padding: 0,
                    width: 30,
                    height: 30,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    outline: "none",
                  }}
                >
                  {/* <MdKeyboardArrowDown fontSize={25} /> */}
                  <PiDotsThreeBold fontSize={25} color="rgba(0, 0, 0, 0.7)" />
                </IconButton>
              }
              transition
              viewScroll="close"
              direction="bottom"
              arrow
              menuStyle={{
                backgroundColor: "white",
                borderRadius: 20,
              }}
              align="end"
            >
              {result.isBlocked !== 5 && result.isBlocked !== 6 && (
                <>
                  {result.isModerator === "1" || result.isModerator === "2" ? (
                    <MenuItem onClick={() => onRemoveAsModerator(result.id)}>
                      <div style={{ display: "flex", alignItems: "center", width: "100%", padding: "0.375rem 1.25rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
                        <MdBlock style={{ fontSize: "18px", marginRight: "10px", flexShrink: 0, color: "rgba(0, 0, 0, 0.7)" }} />
                        <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                          Remove as moderator
                        </span>
                      </div>
                    </MenuItem>
                  ) : (
                    <MenuItem onClick={() => OnInviteAsModerator(result.id)}>
                      <div style={{ display: "flex", alignItems: "center", width: "100%", padding: "0.375rem 1.25rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
                        <img
                          src={crownImage}
                          style={{ width: 18, height: 18, marginRight: 10, flexShrink: 0, objectFit: "contain" }}
                          alt="crownImage"
                        />
                        <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                          Invite as moderator
                        </span>
                      </div>
                    </MenuItem>
                  )}

                  {result?.isImpactableMember?.toLowerCase() === "yes" && (
                    <MenuItem
                      onClick={() =>
                        handleRemoveImpactFullMember(
                          result?.nominatedId,
                          result?.id,
                          tenantId,
                        )
                      }
                    >
                      <div style={{ display: "flex", alignItems: "center", width: "100%", padding: "0.375rem 1.25rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
                        <MdOutlineWarningAmber
                          style={{
                            fontSize: "18px",
                            marginRight: "10px",
                            flexShrink: 0,
                            color: "rgba(0, 0, 0, 0.7)",
                          }}
                        />
                        <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                          Remove from Impactful Member
                        </span>
                      </div>
                    </MenuItem>
                  )}

                  <MenuItem
                    onClick={() => onWarnUser(result.id, result.displayName)}
                  >
                    <div style={{ display: "flex", alignItems: "center", width: "100%", padding: "0.375rem 1.25rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
                      <MdOutlineWarningAmber
                        style={{
                          fontSize: "18px",
                          marginRight: "10px",
                          flexShrink: 0,
                          color: "rgba(0, 0, 0, 0.7)",
                        }}
                      />
                      <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>Send warning</span>
                    </div>
                  </MenuItem>
                </>
              )}

              <MenuItem
                onClick={() =>
                  result.isBlocked === 5 || result.isBlocked === 6
                    ? onUnblockUser(result.id)
                    : onBlockUser(result.id, result.displayName)
                }
              >
                <div style={{ display: "flex", alignItems: "center", width: "100%", padding: "0.375rem 1.25rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
                  <MdBlock
                    style={{
                      fontSize: "18px",
                      marginRight: "10px",
                      flexShrink: 0,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                  />
                  <span style={{ fontSize: "14px", color: "#212529", whiteSpace: "nowrap" }}>
                    {result.isBlocked === 5 || result.isBlocked === 6
                      ? "Unblock User"
                      : "Block User"}
                  </span>
                </div>
              </MenuItem>
            </Menu>
          </div>
        </div>
      ))}
      <WarningModal
        isWarningModalOpen={isWarningModalOpen}
        warnOrBlockUserId={warnOrBlockUserId}
        onWarnModalClose={onWarnModalClose}
        tenantId={tenantId}
        tenantName={tenantName}
        warnOrBlockUserName={warnOrBlockUserName}
        modalType={modalType}
        onRefreshMembersData={getMembersData}
      />
      <ConfirmDialogDemo
        isBlockConfirmationModalOpen={isBlockConfirmationModalOpen}
        onCloseUnBlockConfirmationModal={onCloseUnBlockConfirmationModal}
        warnOrBlockUserId={warnOrBlockUserId}
        tenantId={tenantId}
        onRefreshMembersData={getMembersData}
      />
    </div>
  );
};

export default Members;
